import { gql } from '@apollo/client'
import { CONFIGURATOR_FRAGMENTS } from './ConfiguratorTubesQueryFragments'

export const TUBES = gql`
  query specifications($product: ConfiguratorProductInput!) {
    getSpecifications(product: $product) {
      productDetails
      specifications {
        categoryName
        categoryDisplayName
        specificationModifications {
          name
          displayName
          value
        }
      }
      modifications {
        modificationType
        modificationTypeDisplayName
        category {
          categoryName
          categoryDisplayName
          order
          modifications {
            name
            displayName
            value
            order
            isDefault
          }
        }
      }
    }
  }
`
export const CUSTOM_CRISPR = gql`
  query specificationsForCustomCrispr($product: ConfiguratorProductInput!) {
    getSpecificationsForCustomCrispr(product: $product) {
      productDetails
      specifications {
        categoryName
        categoryDisplayName
        specificationModifications {
          name
          displayName
          value
        }
      }
      modifications {
        modificationType
        modificationTypeDisplayName
        category {
          categoryName
          categoryDisplayName
          order
          modifications {
            name
            displayName
            value
            order
            isDefault
          }
        }
      }
    }
  }
`

export const BITUBE_DETAILS = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query bitubeData($product: ConfiguratorProductInput!) {
    getBitubeData(product: $product) {
      ...BiTubeData
    }
  }
`
export const PLATES = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query modifications($product: ConfiguratorProductInput!) {
    getModifications(product: $product) {
      modifications {
        modificationType
        modificationTypeDisplayName
        category {
          categoryName
          order
          modifications {
            name
            displayName
            value
            order
            isDefault
          }
        }
      }
    }
  }

  query platesSessionData($product: ConfiguratorProductInput!) {
    getSessionDataForPlates(product: $product) {
      ...PlatesData
    }
  }
`

export const ANTISENCE_SEQ = gql`
  query getAntisenceSeq($seq: String!, $product: ConfiguratorProductInput!) {
    getAntisenceSeq(seq: $seq, product: $product) {
      antisenceSeq
      serverError {
        key
        value
      }
    }
  }
`
export const TUBE_SESSION_DATA = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getSessionData($product: ConfiguratorProductInput!) {
    getSessionData(product: $product) {
      ...TubeDataFromSession
    }
  }
`
export const SPECIFICATION_CALCULATION = gql`
  query SpecificationCalculation(
    $input: SpecificationsInput!
    $product: ConfiguratorProductInput!
  ) {
    getSpecificationCalculation(input: $input, product: $product) {
      errorValues {
        valid
        validationType
        key
      }
      calculatedValues {
        amount
        maxConcentration
        scale
        daughterPlateRange
        maxAmount
        maxVolume
        minVolume
      }
    }
  }
`
export const PLATE_PRICE_CALL = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getPlatePriceCall($product: ConfiguratorProductInput!) {
    getPlatePriceCall(product: $product) {
      ...PlatesPriceResponse
    }
  }
`

export const PRODUCT_DETAILS = gql`
  query getProductInformation($input: getProductInformationInput!) {
    getProductInformation(input: $input) {
      productType
      typeCode
      packageType
      instructions
      displayName
      brand
      shippingOptions
      companionProducts
      currencyFormat
      decimalSeparator
      thousandSeparator
      prefixCurrecny
      thousandSpacing
    }
  }
`

export const TUBE_EDIT_LINK = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query tubeEditLink($product: tubeEditInput) {
    tubeEditLink(product: $product) {
      ...TubeDataFromSession
    }
  }
`

export const CRISPR_SESSION_DATA = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getCrisprSessionData($product: ConfiguratorProductInput!) {
    getCrisprSessionData(product: $product) {
      ...CrisprSessionResponse
    }
  }
`
export const MILLIPLEX_SEARCH_ANALYTES = gql`
  query milliplexSearchAnalytes(
    $input: String!
    $product: ConfiguratorProductInput!
  ) {
    milliplexSearchAnalytes(input: $input, product: $product) {
      requestDate
      responseDate
      count
      version
      term
      termCount
      assays {
        panelId
        panelName
        assayType
        customPremixedAvailable
        requireSample
        researchAreaOracle
        species
        researchAreas
        type
        listSampleType
        customPremixSelection
        spaceSaverSelection
        decisionTableVer
        listSearchResultModelErrors {
          key
          value
        }
        listWarnings {
          key
          value
        }
        listAnalytes
        selectedAnalytes
        price
        allAnalytesSelected
        mutualAnalytesList
        analytes
        quantity
        material
        spaceSaver
        name
        sampleType
        id
        productTotal
      }
    }
  }
`
export const CRISPR_PRICE_CALL = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getCrisprPriceCall($product: ConfiguratorProductInput!) {
    getCrisprPriceCall(product: $product) {
      ...CrisprPriceResponse
    }
  }
`

export const ANTISERA_SESSION_DATA = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getAntiseraSessionData($product: ConfiguratorProductInput!) {
    getAntiseraSessionData(product: $product) {
      ...AntiseraSessionDataResponse
    }
  }
`
export const MILLIPLEX_GET_SESSION_DATA = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getMilliplexSessionData($product: ConfiguratorProductInput!) {
    getMilliplexSessionData(product: $product) {
      ...MilliplexSessionDataResponse
    }
  }
`
export const SIMPLE_ANTISERA_SESSION_DATA = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getSimpleAntiseraSessionData($product: ConfiguratorProductInput!) {
    getSimpleAntiseraSessionData(product: $product) {
      ...SimpleAntiseraSessionResponse
    }
  }
`
export const BITUBE_EDIT_LINK = gql`
  query bitubeEditLink($product: tubeEditInput) {
    bitubeEditLink(product: $product) {
      ...BiTubeData
    }
  }
`
export const CONF_CONTACT_DETAILS = gql`
  query getConfContactDetails($country: String) {
    getConfContactDetails(country: $country) {
      phone
      email
    }
  }
`

export const CUSTOM_CRISPR_EDIT_LINK = gql`
  query customCrisprEditLink($product: ConfiguratorProductInput!) {
    customCrisprEditLink(product: $product) {
      ...CrisprSessionResponse
    }
  }
`
export const SIMPLE_ANTISERA_EDIT_LINK = gql`
  query simpleAntiseraEditLink($product: ConfiguratorProductInput!) {
    simpleAntiseraEditLink(product: $product) {
      ...SimpleAntiseraSessionResponse
    }
  }
`
export const ANTISERA_EDIT_LINK = gql`
  query antiseraEditLink($product: ConfiguratorProductInput!) {
    antiseraEditLink(product: $product) {
      ...AntiseraSessionDataResponse
    }
  }
`
export const PRODUCTS = gql`
  query getCustomOligoProducts($input: ConfiguratorProductInput!) {
    getCustomOligoProducts(input: $input) {
      products
    }
  }
`

export const NGSO_PRICE_CALL = gql`
  ${CONFIGURATOR_FRAGMENTS}
  query getNgsoPriceCall($product: ConfiguratorProductInput!) {
    getNgsoPriceCall(product: $product) {
      ...NgsoPriceResponse
    }
  }
`
